<template>
  <svg
    :height="height"
    :width="width"
    id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
       viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve">
    <path style="fill:#EADCD6;" d="M453.006,430.184H99.903c-22.593,0-40.909,18.316-40.909,40.909l0,0
      c0,22.593,18.316,40.909,40.909,40.909h342.122c6.064,0,10.981-4.916,10.981-10.981L453.006,430.184L453.006,430.184z"/>
    <path style="fill:#DDCDC7;" d="M79.785,471.091c0-22.593,18.316-40.909,40.909-40.909H99.903c-22.593,0-40.909,18.315-40.909,40.909
      S77.309,512,99.903,512h20.791C98.101,512,79.785,493.685,79.785,471.091z"/>
    <g>
      <path style="fill:#C9BCB8;" d="M408.653,465.183H127.032c-4.268,0-7.726-3.46-7.726-7.726s3.46-7.726,7.726-7.726h281.621
        c4.268,0,7.726,3.46,7.726,7.726S412.921,465.183,408.653,465.183z"/>
      <path style="fill:#C9BCB8;" d="M408.653,492.455H127.032c-4.268,0-7.726-3.46-7.726-7.726c0-4.267,3.46-7.726,7.726-7.726h281.621
        c4.268,0,7.726,3.46,7.726,7.726C416.379,488.995,412.921,492.455,408.653,492.455z"/>
    </g>
    <path style="fill:#FCD98B;" d="M440.519,8.182c-7.843,0-329.602,0-340.615,0c-22.593,0-40.909,18.315-40.909,40.909v422.002
      c0-22.593,18.315-40.909,40.909-40.909h353.103V20.669C453.006,13.772,447.415,8.182,440.519,8.182z"/>
    <path style="fill:#FFD261;" d="M129.551,8.182c-16.851,0-27.77,0-29.648,0c-22.593,0-40.909,18.315-40.909,40.909v422.002
      c0-22.593,18.315-40.909,40.909-40.909h29.648V8.182z"/>
    <path style="fill:#F8BF00;" d="M368.322,84.79c-3.751,0-174.702,0-180.171,0c-4.676,0-8.466,3.791-8.466,8.466
      c0,102.932-0.074,96.752,0.173,97.956c0.79,3.858,4.203,6.76,8.294,6.76l0,0h180.171l0,0c4.091,0,7.504-2.902,8.294-6.76
      c0.246-1.2,0.172,5.112,0.172-97.956C376.787,88.58,372.997,84.79,368.322,84.79z"/>
    <path style="fill:#EFA603;" d="M200.462,191.212c-0.247-1.204-0.173,4.976-0.173-97.956c0-4.676,3.79-8.466,8.466-8.466
      c-11.739,0-19.507,0-20.604,0c-4.676,0-8.466,3.791-8.466,8.466c0,102.932-0.074,96.752,0.173,97.956
      c0.79,3.858,4.203,6.76,8.294,6.76h20.604C204.664,197.972,201.251,195.07,200.462,191.212z"/>
    <path style="fill:#F8BF00;" d="M287.709,56.387h-18.947c-4.268,0-7.726-3.46-7.726-7.726s3.46-7.726,7.726-7.726h18.947
      c4.268,0,7.726,3.46,7.726,7.726S291.977,56.387,287.709,56.387z"/>
    <path style="fill:#B5E3EA;" d="M147.35,0c-3.706,0-6.711,3.004-6.711,6.711v130.412c0,3.339,3.672,5.375,6.504,3.605l32.541-20.339
      L182.633,0H147.35z"/>
    <path style="fill:#90D8E0;" d="M161.637,6.711c0-3.706,3.004-6.711,6.711-6.711h-20.996c-3.706,0-6.711,3.004-6.711,6.711v130.412
      c0,3.339,3.672,5.375,6.504,3.605l14.493-9.058V6.711H161.637z"/>
    <path style="fill:#E1F3F9;" d="M212.019,0c3.706,0,6.711,3.004,6.711,6.711v130.412c0,3.339-3.672,5.375-6.504,3.605l-32.541-20.339
      V0H212.019z"/>
    <path style="fill:#F8BF00;" d="M108.945,8.181h-9.043c-22.593,0-40.909,18.316-40.909,40.909v422.002
      c0-22.593,18.316-40.909,40.909-40.909h9.043C108.945,430.183,108.945,8.181,108.945,8.181z"/>
    <path style="fill:#EFA603;" d="M79.972,13.367c-12.513,6.997-20.978,20.368-20.978,35.723v422.002
      c0-15.354,8.464-28.726,20.977-35.722V13.367H79.972z"/>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
